import React from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {observer} from 'mobx-react-lite';

import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import {useTabBarBottomPadding} from '../../hooks/useTabBarBottomPadding';
import CelebrationIcon from '../../images/brand/svg/icons/Celebration.svg';
import Button from '../themed/Button';

type SuccessGenericProps = {
  onPressHome: () => void;
  text: string;
  ctaTitle?: string;
};

/**
 * This is a generic success screen component
 */
const SuccessGeneric = observer(({onPressHome, text, ctaTitle}: SuccessGenericProps) => {
  // DIS-1763: on web mobile the tab bar floats over the content, so the CTA
  // needs room below it to scroll clear.
  const tabBarPadding = useTabBarBottomPadding();

  return (
    <KeyboardAwareScrollView
      style={{backgroundColor: 'white'}}
      contentContainerStyle={{paddingBottom: tabBarPadding}}
      keyboardShouldPersistTaps="always">
      <ContentView>
        <View
          style={{
            padding: 20,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CelebrationIcon width={113} height={115} />
        </View>
        <Text variant="heading1">Congrats!</Text>
        <Text variant="body2">{text}</Text>
        <View style={{gap: 8, marginTop: 40}}>
          <Button
            secondary
            title={ctaTitle || `GO TO ${config.APP_NAME.toUpperCase()} HOME`}
            onPress={onPressHome}
          />
        </View>
      </ContentView>
    </KeyboardAwareScrollView>
  );
});

export default SuccessGeneric;
